import {RoomSetting} from "@/core/api/room.setting.api";

export default {
    changeCameraRole: async ({ dispatch, commit, getters, rootGetters }, cameraOn) => {
        return await RoomSetting.changeCameraRole(cameraOn)
    },
    changeMicRole: async ({ dispatch, commit, getters, rootGetters }, micOn) => {
        return await RoomSetting.changeMicRole(micOn)
    },
    changeResetRole: async ({ dispatch, commit, getters, rootGetters }, reset) => {
        return await RoomSetting.changeResetRole(reset)
    },
    changeDefaultRoleId: async ({ dispatch, commit, getters, rootGetters }, defaultRoleId) => {
        return await RoomSetting.changeDefaultRoleId(defaultRoleId)
    },
    changeDefaultDevice: async ({ dispatch, commit, getters, rootGetters }, defaultDevice) => {
        return await RoomSetting.changeDefaultDevice(defaultDevice)
    },
    changeChatMode: async ({ dispatch, commit, getters, rootGetters }, chatMode) => {
        return await RoomSetting.changeChatMode(chatMode)
    },
    changeWaitingMode: async ({ dispatch, commit, getters, rootGetters }, waitingMode) => {
        return await RoomSetting.changeWaitingMode(waitingMode)
    },
    changeDeviceRequired: async ({ dispatch, commit, getters, rootGetters }, waitingMode) => {
        return await RoomSetting.changeDeviceRequired(waitingMode)
    },
    changeTranslateMode: async ({ dispatch, commit, getters, rootGetters }, translateMode) => {
        return await RoomSetting.changeTranslateMode(translateMode)
    },
    changeStickerMode: async ({ dispatch, commit, getters, rootGetters }, stickerMode) => {
        return await RoomSetting.changeStickerMode(stickerMode)
    },
    changeDocMargin: async ({ dispatch, commit, getters, rootGetters }, docMargin) => {
        return await RoomSetting.changeDocMargin(docMargin)
    },
    changeUseQnA: async ({ dispatch, commit, getters, rootGetters }, useQnA) => {
        return await RoomSetting.changeUseQnA(useQnA)
    },
    changeUseQnAShare: async ({ dispatch, commit, getters, rootGetters }, useQnAShare) => {
        return await RoomSetting.changeUseQnAShare(useQnAShare)
    },
    // changeWebinarType: async ({ dispatch, commit, getters, rootGetters }, webinarType) => {
    //     return await RoomSetting.changeUseQnAShare(webinarType)
    // },
}